export default __webpack_public_path__ + "static/media/18.25ff4b6e.png";